var render = function render(){var _vm=this,_c=_vm._self._c;return _c('s-modal-card',{attrs:{"accept":_vm.accept,"cancel":_vm.cancel}},[_c('template',{slot:"title"},[_vm._v("\n    Confirm\n  ")]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_vm._v("Are you sure?")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }